package com.exura.features.plandefinition.usecase

import com.exura.features.plandefinition.domain.model.plan.BasePlan
import com.exura.features.plandefinition.domain.repository.ProviderPlanDefinitionRepository

class CreateUnversionedPlanDefinitionUseCase(
    private val repository: ProviderPlanDefinitionRepository
) {
    suspend operator fun invoke(plan: BasePlan): Result<BasePlan> {
        return try {
            repository.create(plan)
        } catch (e: Exception) {
            println("Error creating plan: ${e.message}")
            e.printStackTrace()
            Result.failure(e)
        }
    }
}
